module.exports = "<div class=\"navigation\" (click)=\"navigate()\">\r\n  <i class=\"fas fa-home fa-fa-lg\"></i>\r\n</div>\r\n<!-- <app-footer></app-footer> -->"